module.exports = __webpack_public_path__ + "static/media/float_schemes.412dd360.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/float_schemes.svg
// module id = 387
// module chunks = 0